import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { actions } from './actions';
import { mutations } from './mutations';
import { ProvozovnaDropdownList, Edit, LocalState } from './state';
import { NAME as name, CRUMB_LABEL_KEY } from '../../constants';
import { apiProvider } from '../../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: new ProvozovnaDropdownList(),
	edit: new Edit(),
	depTableNames: [],
	depTableSettings: {},
	localState: new LocalState(),
	extraActions: actions,
	extraGetters: {},
	extraMutations: mutations,
	props: {
		mode: null,
	},
});
